import React from "react";
import { motion } from "framer-motion";
import { Compass, Eye, Flame } from "lucide-react";

const PILLARS = [
  {
    icon: Compass,
    title: "Mission",
    text: "Build the growth engine Indian music deserves — pairing two decades inside the scene with modern marketing systems, so artists and music businesses scale on their own terms.",
  },
  {
    icon: Eye,
    title: "Vision",
    text: "A scene where great music never dies quietly — every artist and music business with a clear, honest path from the studio to a growing audience.",
  },
  {
    icon: Flame,
    title: "Core Values",
    text: "Musicians first — we come from the stage, not a sales deck. No fluff, only true facts. End-to-end ownership from content to campaigns. Consistency compounds.",
  },
];

export const AboutSection = () => {
  return (
    <section className="relative py-14 sm:py-18" data-testid="about-section">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.3 }}
          transition={{ duration: 0.6 }}
          className="text-center mb-10"
        >
          <p className="font-mono-ui text-[11px] tracking-[0.35em] uppercase text-[color:var(--hs-ink-dim)]">
            About Holdstill
          </p>
          <h2 className="mt-3 font-display font-display-rough uppercase text-3xl sm:text-4xl text-white">
            Built by musicians. <span className="text-[color:var(--hs-lime)]">Run like a system.</span>
          </h2>
        </motion.div>

        <div className="grid md:grid-cols-3 gap-4 sm:gap-5">
          {PILLARS.map((pillar, i) => {
            const Icon = pillar.icon;
            return (
              <motion.div
                key={pillar.title}
                initial={{ opacity: 0, y: 28 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, amount: 0.3 }}
                transition={{ duration: 0.55, delay: i * 0.1, ease: [0.2, 0.8, 0.2, 1] }}
                className="rounded-2xl border border-white/10 bg-black/30 p-6 sm:p-7"
                data-testid={`about-pillar-${pillar.title.toLowerCase().replace(" ", "-")}`}
              >
                <span className="h-10 w-10 rounded-xl bg-[rgba(202,255,26,0.12)] border border-[rgba(202,255,26,0.3)] flex items-center justify-center">
                  <Icon className="h-4.5 w-4.5 text-[color:var(--hs-lime)]" size={18} />
                </span>
                <h3 className="mt-4 font-display uppercase text-lg text-white tracking-wide">{pillar.title}</h3>
                <p className="mt-2.5 text-sm leading-relaxed text-[color:var(--hs-ink-dim)]">{pillar.text}</p>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
